//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BBreadcrumb, BCard, BCardBody } from "bootstrap-vue";
import { Icon } from "@iconify/vue2";
import { getCourseDurationText } from "~/utils/course";
import { isCoursePaused } from "~/data/pausedCourses";
import { calculateDiscountedPrice } from "~/utils/discount";
import { resolveCoursePageState } from "~/utils/coursePageState";

export default {
  name: "Curso",
  layout: "default",
  components: { BBreadcrumb, BCard, BCardBody, Icon },
  async asyncData(context) {
    const result = await resolveCoursePageState(context.params.curso);
    if ("redirect" in result) {
      context.redirect(context.localePath("404"));
      return;
    }
    return { ...result, pageReady: true };
  },
  head() {
    if (this.coursePaused && this.coursePreview) {
      return {
        title: `${this.coursePreview.name} — en actualización`,
        meta: [
          {
            hid: "description",
            name: "description",
            content: `El curso ${this.coursePreview.name} está temporalmente en pausa mientras lo mejoramos. Explorá otros cursos en Abstracta Academy.`,
          },
          { hid: "robots", name: "robots", content: "noindex, follow" },
        ],
      };
    }
    if (!this.courseInfo) return {};
    const { title, description, keywords, imageUrl } =
      this.courseInfo.metaTags || {};
    return {
      title: title || "Curso",
      meta: [
        {
          hid: "description",
          name: "description",
          content: description || "Información del curso",
        },
        { hid: "keywords", name: "keywords", content: keywords || "" },
        { hid: "og:image", property: "og:image", content: imageUrl || "" },
      ],
    };
  },
  data() {
    return {
      pageReady: false,
      coursePaused: false,
      coursePreview: null,
      suggestedCourses: [],
      courseInfo: null,
      floatingCardBottomLimit: Number.MAX_VALUE,
      pricePesos: 0,
      category: "",
      paymentMethod: ["paypal"],
    };
  },
  computed: {
    breadcrumbItems() {
      const cat = this.courseInfo?.category;
      const firstCategory = Array.isArray(cat) ? cat[0] : cat;
      return [
        { text: "Cursos", to: this.localePath("/cursos") },
        {
          text: firstCategory || "",
          to: {
            path: this.localePath(`/cursos?category=${firstCategory}`),
            hash: "#cursos",
          },
        },
        { text: this.courseInfo?.name || "", active: true },
      ];
    },
  },
  methods: {
    calculateFloatingCardLimit() {
      if (this.$refs["card-specialization"]) {
        const { $el: el } = this.$refs["card-specialization"];
        const { top, height } = el.getBoundingClientRect();
        this.floatingCardBottomLimit =
          document.documentElement.scrollTop + top + height;
      } else if (this.$refs["card-bioinstructors"]) {
        const { $el: el } = this.$refs["card-bioinstructors"];
        const { top, height } = el.getBoundingClientRect();
        this.floatingCardBottomLimit =
          document.documentElement.scrollTop + top + height;
      } else if (this.$refs["card-modules"]) {
        const { $el: el } = this.$refs["card-modules"];
        const { top, height } = el.getBoundingClientRect();
        this.floatingCardBottomLimit =
          document.documentElement.scrollTop + top + height;
      }
    },

    getCourseDurationText,
    onBtnClick() {
      // calcular precios con descuento usando solo el shortName
      const discountedPriceUSD = calculateDiscountedPrice(this.courseInfo.priceUSD, this.courseInfo.shortName);
      const discountedPricePesos = Math.round(discountedPriceUSD * parseFloat(window.sessionStorage.getItem("dolarPrice")) * 1.22);
      
      // set course data in sessionStorage
      const courseData = {
        name: this.courseInfo.name,
        shortName: this.courseInfo.shortName,
        priceUSD: discountedPriceUSD,
        pricePesos: discountedPricePesos,
        originalPriceUSD: this.courseInfo.priceUSD,
        originalPricePesos: this.pricePesos,
        img: this.courseInfo.image,
        language: this.courseInfo.language,
        level: this.courseInfo.level,
        duration: this.courseInfo.duration,
        dateCourse: this.courseInfo.dateCourse,
        slug: this.courseInfo.slug,
        shortDescription: this.courseInfo.shortDescription,
        graduationCertificate: this.courseInfo.graduationCertificate,
        talentCourseIds: this.courseInfo.talentCourseIds || [],
      };

      Object.entries(courseData).forEach(([key, value]) => {
        try {
          if (key === "pricePesos" || key === "priceUSD" || key === "originalPriceUSD" || key === "originalPricePesos") {
            const numValue = parseFloat(value);
            sessionStorage.setItem(
              `course_${key}`,
              isNaN(numValue) ? "0" : numValue.toString()
            );
          } else {
            sessionStorage.setItem(`course_${key}`, JSON.stringify(value));
          }
        } catch (e) {
          console.error(`Error guardando ${key}:`, e);
          sessionStorage.setItem(`course_${key}`, value);
        }
      });

      // usamos el LoginSheet global
      const token = sessionStorage.getItem("login_key");
      if (token) {

        this.$router.push(this.localePath("/pago/" + this.courseInfo.slug));
      } else {
        // si no está autenticado, se guardan los datos y se muestra el modal de login
        if (this.$root.$loginSheet) {
          this.$root.$loginSheet.$once("auth-success", () => {
            this.$router.push(this.localePath("/pago/" + this.courseInfo.slug));
          });
          this.$modal.show("login-sheet");
        } else {
          console.error("LoginSheet no está disponible");
        }
      }
    },
  },
  async mounted() {
    const cursoId = this.$route.params.curso;

    if (isCoursePaused(cursoId) && (!this.coursePaused || this.courseInfo)) {
      const result = await resolveCoursePageState(cursoId);
      if ("redirect" in result) {
        this.$router.push(this.localePath("404"));
        return;
      }
      this.coursePaused = result.coursePaused;
      this.coursePreview = result.coursePreview;
      this.suggestedCourses = result.suggestedCourses;
      this.courseInfo = result.courseInfo;
    }

    this.pageReady = true;

    if (!this.courseInfo) return;

    this.category =Array.isArray(this.courseInfo.category)
    ? this.courseInfo.category[0]
    : this.courseInfo.category;
    //
    this.$nextTick(() => {
      window.addEventListener("resize", this.calculateFloatingCardLimit);
      this.calculateFloatingCardLimit();
    });

    let dolarPrice = window.sessionStorage.getItem("dolarPrice");
    if (dolarPrice) dolarPrice = parseFloat(dolarPrice);
    else {
      const res = await this.$api.cotizacion.getCotizacion({ monedas: [2225] });
      dolarPrice = res[0].TCV;
      window.sessionStorage.setItem("dolarPrice", dolarPrice);
    }

    // this.pricePesos = parseFloat((this.courseInfo.priceUSD * dolarPrice) * 1.22).toFixed(2); //
    this.pricePesos = Math.round(this.courseInfo.priceUSD * dolarPrice * 1.22);
    // this.pricePesos = this.courseInfo.pricePesos;
    sessionStorage.setItem("courseName", this.courseInfo.name);
    sessionStorage.setItem("courseBadgeImg", this.courseInfo.badgeImg);
    sessionStorage.setItem("coursePriceUSD", this.courseInfo.priceUSD);
    sessionStorage.setItem("coursePricePesos", this.pricePesos);
    sessionStorage.setItem("courseTalentLink", this.courseInfo.talentLink);
    if (this.courseInfo.talentCourseIds?.length) {
      sessionStorage.setItem(
        "courseTalentCourseIds",
        JSON.stringify(this.courseInfo.talentCourseIds)
      );
    } else {
      sessionStorage.removeItem("courseTalentCourseIds");
    }

    this.paymentMethod = sessionStorage.coursePaymentMethod;
  },
  watch: {},
};
